import "./App.css";
import "animate.css";
import Home from "./app/pages/Home";

function App() {
  return <Home />;
}

export default App;
